




















































































import Vue, { PropType } from "vue";
import { Adunit } from "@/features/adunitGroup/types";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
// utils
import { getTotalPage } from "@/commons/utils/getTotalPage";
import { omitText } from "@/features/adunitGroup/utils";

extend("emojiSyntax", {
  validate(value) {
    const emojiRegex = new RegExp(require("emoji-regex"));
    return !emojiRegex.test(value);
  },
});

export default Vue.extend({
  name: "AdunitSelector",
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  props: {
    adunitList: {
      type: Array as PropType<Adunit[]>,
      required: true,
    },
    selectedAdunitList: {
      type: Array as PropType<Adunit[]>,
      required: true,
    },
    selectedAdunitIdList: { type: Array as PropType<number[]>, required: true },
    totalAdunit: { type: Number, required: true },
    isLoading: { type: Boolean, required: true },
    updateAdunitList: { type: Function, required: true },
    searchName: { type: String, required: true },
    pageIndex: { type: Number, required: true },
  },
  computed: {
    childSelectedAdunitList: {
      get(): Adunit[] {
        return this.selectedAdunitList;
      },
      set(val: Adunit[]) {
        this.$emit("update:selectedAdunitList", val);
      },
    },
    childSelectedAdunitIdList: {
      get(): number[] {
        return this.selectedAdunitIdList;
      },
      set(adunitIdList: number[]) {
        this.$emit("update:selectedAdunitIdList", adunitIdList);
      },
    },
    childSearchName: {
      get(): string {
        return this.searchName;
      },
      set(val: string) {
        this.$emit("update:searchName", val);
      },
    },
    totalPage(): number {
      return getTotalPage(this.totalAdunit);
    },
    childPageIndex: {
      get(): number {
        return this.pageIndex;
      },
      set(val: number) {
        this.$emit("update:pageIndex", val);
      },
    },
  },
  methods: {
    onClickCloseIcon(adunitId: number) {
      this.$emit("removeItem", adunitId);
    },
    updateAdunit(isSearch = false) {
      // バリデーション
      (this.$refs.adunitSelector as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (succsess: boolean) => {
          if (!succsess) return;

          // 検索の場合はページ番号を先頭に
          if (isSearch) {
            this.childPageIndex = 1;
            this.updateAdunitList({
              adunitName: this.childSearchName,
              index: 1,
            });
          } else {
            this.updateAdunitList({
              adunitName: this.childSearchName,
              index: this.childPageIndex,
            });
          }
        });
    },
    // 選択済み枠リストに引数の adunit で追加 or 削除
    changeSelectedAdunitList(adunit: Adunit) {
      // 含まれていない場合は追加
      if (!this.childSelectedAdunitList.some(value => value.adunitId === adunit.adunitId)) {
        this.childSelectedAdunitList.push(adunit);
        return;
      }
      // 既に含まれている場合は削除
      this.childSelectedAdunitList = this.childSelectedAdunitList.filter(
        value => value.adunitId !== adunit.adunitId
      );
    },
    omitText(text: string) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return omitText(text, 15);
        case "sm":
          return omitText(text, 25);
        case "md":
          return omitText(text, 40);
        case "lg":
          return omitText(text, 55);
        case "xl":
          return omitText(text, 70);
      }
    },
  },
});
